import { useDispatch } from 'react-redux';

import { initCustomer } from '../../slices/Customer/customerSlice';
import { upsertOrder } from '../../slices/OrderSummary/orderSummarySlice';
import {
	initIsAdmin,
	initSalesAgent,
	initSalesGroup,
} from '../../slices/System/systemSlice';

import { STORAGE_KEYS } from '../../utils/constants/storage-keys';
import { sessionStorageHelper } from '../../utils/storage-helpers/session-storage-helper';

const persistingConfiguration = [
	{
		key: STORAGE_KEYS.BV_CUSTOMER_SUMMARY,
		initializer: initCustomer as any,
	},
	{
		key: STORAGE_KEYS.BV_ORDER_SUMMARY,
		initializer: upsertOrder as any,
	},
	{
		key: STORAGE_KEYS.BV_SYSTEM_SALES_AGENT,
		initializer: initSalesAgent as any,
	},
	{
		key: STORAGE_KEYS.BV_SYSTEM_IS_ADMIN,
		initializer: initIsAdmin as any,
	},
	{
		key: STORAGE_KEYS.BV_SYSTEM_SALES_GROUP,
		initializer: initSalesGroup as any,
	},
];

export const usePersistReduxStore = () => {
	const dispatch = useDispatch();

	const handlePersistingStore = () => {
		persistingConfiguration.forEach((configuration) => {
			let persistedData: any = sessionStorageHelper.getStorageItem(
				configuration.key,
			);
			if (persistedData) {
				dispatch(configuration.initializer(persistedData));
			}
		});
	};

	return {
		handlePersistingStore,
	};
};
